// extracted by mini-css-extract-plugin
export default {"faculty-photos":"FacultyPhotos_faculty-photos__REIdS","title":"FacultyPhotos_title__+NG5E"};